import { FC, MouseEvent } from 'react';
import { Box, IconButton } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { IMGSEARCHV2 } from '../../imageSearchV2.classes';

interface SCUIImageThumbnailV2Props {
    src: string;
    previewSrc?: string;
    alt?: string;
    onPreview: (uri: string) => void;
    onSelect?: () => void;
    disabled?: boolean;
    className?: string;
    imageClassName?: string;
    imageStyle?: React.CSSProperties;
    containerStyle?: React.CSSProperties;
    children?: React.ReactNode;
}

export const SCUIImageThumbnailV2: FC<SCUIImageThumbnailV2Props> = ({
    src,
    previewSrc,
    alt = 'Product',
    onPreview,
    onSelect,
    disabled = false,
    className,
    imageClassName,
    imageStyle,
    containerStyle,
    children,
}) => {
    const handlePreviewClick = (event: MouseEvent) => {
        event.stopPropagation();
        const previewUrl = previewSrc || src;
        if (previewUrl) {
            onPreview(previewUrl);
        }
    };

    const handleSelectClick = () => {
        if (disabled || !onSelect) {
            return;
        }
        onSelect();
    };

    return (
        <Box
            className={className ?? IMGSEARCHV2.imageThumbWrap}
            onClick={handleSelectClick}
            sx={{
                position: 'relative',
                overflow: 'hidden',
                cursor: onSelect && !disabled ? 'pointer' : 'default',
                ...containerStyle,
                '&:hover .image-search-v2-thumb__magnify-button': {
                    opacity: 1,
                },
            }}
        >
            <img
                className={imageClassName ?? IMGSEARCHV2.imageThumbImage}
                src={src}
                alt={alt}
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', ...imageStyle }}
            />
            <IconButton
                className={`${IMGSEARCHV2.imageThumbMagnifyButton} image-search-v2-thumb__magnify-button`}
                aria-label="preview"
                onClick={handlePreviewClick}
                disabled={disabled || !src}
                size="small"
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 3,
                    opacity: 0,
                    transition: 'opacity 0.2s ease',
                    color: 'white',
                    bgcolor: 'rgba(0,0,0,0.55)',
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.75)' },
                }}
            >
                <ZoomInIcon fontSize="small" />
            </IconButton>
            {children}
        </Box>
    );
};
